import { combineEpics, ofType } from 'redux-observable';
import { switchMap, map, catchError, tap, of, from } from 'rxjs';
import { fetchUsermenu, setIsLoggedIn, setUser } from '../store/dashboard/AuthSlice';
import AuthFacade from '../facade/auth.Facade';

const logoutEpic = (action$: any) =>
    action$.pipe(
        ofType('auth/logout'),
        switchMap(() => {
            localStorage.clear();
            window.location.href = `${process.env.REACT_APP_DEV_URL}Account/LogOut?app=${process.env.REACT_APP_API_BASE_URL}`;
            return of(setIsLoggedIn({ payload: false }));
        })
    );

const fetchUserEpic = (action$: any) =>
    action$.pipe(
        ofType('auth/fetchUser '),
        switchMap(() => {
            return from(AuthFacade().getUser()).pipe(
                map(user => setUser({ payload: user })),
                catchError((error) => {
                    console.log(error);
                    return of(setUser({ payload: null }));
                })
            );
        })
    );

const fetchMenuEpic = (action$: any, state$: any) =>
    action$.pipe(
        ofType('auth/fetchUsermenu'),
        switchMap(() => {
            const body = {
                Orgid: 4,
                user: state$.value.auth.user,
            };
            return from(AuthFacade().getUserMenu(body)).pipe(
                map(menu => fetchUsermenu({ payload: menu })),
                catchError((error) => {
                    console.log(error);
                    return of(fetchUsermenu({ payload: [] }));
                })
            );
        })
    );

export const authEpic = combineEpics(
    logoutEpic,
    fetchUserEpic,
    fetchMenuEpic
);